import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {DxModalButton} from "./dx-modal-button";


/** Опции модального окна. */
@jsonObject
export class DxModalOptions {
  /** Название модалки в шапке */
  @jsonMember({name: "title", constructor: String, emitDefaultValue: false, isRequired: false})
  private _title: string;

  /** Показывать \ не крестик в шапке модалки. */
  @jsonMember({name: "showCrossBtn", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _showCrossBtn: boolean = true;

  /** Закрывать \ не закрывать модаку при клике вне ее. */
  @jsonMember({name: "closeOnBackgroundClick", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _closeOnBackgroundClick: boolean = false;

  @jsonMember({name: "bodyIcon", constructor: String, emitDefaultValue: false, isRequired: false})
  private _bodyIcon: string;

  /**
   * Размер модального окна.
   * Допустимые значения: `"mini" | "tiny" | "small" | "normal" | "large"`.
   */
  @jsonMember({name: "size", constructor: String, emitDefaultValue: false, isRequired: false})
  private _size: string = 'small';

  @jsonArrayMember(DxModalButton, {name: "buttons", emitDefaultValue: false, isRequired: false })
  private _buttons: DxModalButton[] = [];


  get title(): string {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
  }

  get showCrossBtn(): boolean {
    return this._showCrossBtn;
  }

  set showCrossBtn(value: boolean) {
    this._showCrossBtn = value;
  }

  get closeOnBackgroundClick(): boolean {
    return this._closeOnBackgroundClick;
  }

  set closeOnBackgroundClick(value: boolean) {
    this._closeOnBackgroundClick = value;
  }

  get size(): string {
    return this._size;
  }

  set size(value: string) {
    this._size = value;
  }

  get bodyIcon(): string {
    return this._bodyIcon;
  }

  set bodyIcon(value: string) {
    this._bodyIcon = value;
  }

  get buttons(): DxModalButton[] {
    return this._buttons;
  }

  set buttons(value: DxModalButton[]) {
    this._buttons = value;
  }
}
